var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHraCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ffbb00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6191 7.72536L11.498 5.67225C11.3691 5.54676 11.193 5.4753 11.0118 5.4753L7.01708 5.46484C6.53256 5.46484 6.13867 5.85525 6.13867 6.33628V13.5135C6.13867 13.9858 6.54476 14.3867 7.0258 14.3867H12.9342C13.4065 14.3867 13.7899 13.9945 13.7899 13.5117V8.14191C13.7899 7.97982 13.7289 7.83168 13.6191 7.72536ZM11.4893 6.63432L12.5856 7.69399H11.6793C11.5782 7.69399 11.4893 7.61556 11.4893 7.52667V6.63432ZM12.9342 13.6895H7.0258C6.9282 13.6895 6.83582 13.6041 6.83582 13.5117V6.33628C6.83582 6.24391 6.92123 6.162 7.01708 6.162L10.7922 6.17245V7.52667C10.7922 8.00248 11.1895 8.39114 11.6793 8.39114H13.0928V13.5117C13.0928 13.5989 13.0335 13.6895 12.9342 13.6895Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24203 7.42578C8.02083 7.42578 7.83984 7.60676 7.83984 7.82796V12.1715C7.83984 12.3927 8.02083 12.5737 8.24203 12.5737C8.46323 12.5737 8.64421 12.3927 8.64421 12.1715V7.82796C8.64421 7.60676 8.46323 7.42578 8.24203 7.42578Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8514 8.47266C9.6302 8.47266 9.44922 8.65364 9.44922 8.87484V12.1727C9.44922 12.3939 9.6302 12.5749 9.8514 12.5749C10.0726 12.5749 10.2536 12.3939 10.2536 12.1727V8.87484C10.2536 8.65364 10.0726 8.47266 9.8514 8.47266Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4608 9.51758C11.2396 9.51758 11.0586 9.69856 11.0586 9.91976V12.172C11.0586 12.3932 11.2396 12.5742 11.4608 12.5742C11.682 12.5742 11.863 12.3932 11.863 12.172V9.91976C11.863 9.69856 11.682 9.51758 11.4608 9.51758Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHraCardIcon);
export default __webpack_public_path__ + "static/media/hra-card-icon.918e6afe5be2f50d7b07615db592ade3.svg";
export { ForwardRef as ReactComponent };